if (!customElements.get('call-widget-button')) {
  customElements.define(
    'call-widget-button',
    class CallWidgetButton extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.call-widget__trigger');
        this.overlay = this.querySelector('.call-widget__overlay');
        this.sheet  = this.querySelector('.call-widget__sheet');
        this.closeBtn = this.querySelector('.call-widget__close');

        this._onTriggerClick = () => this.open();
        this._onOverlayClick = () => this.close();
        this._onCloseClick   = () => this.close();
        this._onKeyDown      = (e) => { if (e.key === 'Escape') this.close(); };

        this.trigger.addEventListener('click', this._onTriggerClick);
        this.overlay.addEventListener('click', this._onOverlayClick);
        this.closeBtn.addEventListener('click', this._onCloseClick);
        document.addEventListener('keydown', this._onKeyDown);
      }

      open() {
        this.overlay.removeAttribute('hidden');
        this.sheet.removeAttribute('hidden');

        // Trigger reflow so CSS transitions fire
        this.overlay.offsetHeight;
        this.sheet.offsetHeight;

        this.overlay.classList.add('is-visible');
        this.sheet.classList.add('is-visible');
        this.closeBtn.focus();
      }

      close() {
        this.overlay.classList.remove('is-visible');
        this.sheet.classList.remove('is-visible');

        const onTransitionEnd = () => {
          this.overlay.setAttribute('hidden', '');
          this.sheet.setAttribute('hidden', '');
          this.overlay.removeEventListener('transitionend', onTransitionEnd);
        };

        this.overlay.addEventListener('transitionend', onTransitionEnd);
        this.trigger.focus();
      }

      disconnectedCallback() {
        this.trigger.removeEventListener('click', this._onTriggerClick);
        this.overlay.removeEventListener('click', this._onOverlayClick);
        this.closeBtn.removeEventListener('click', this._onCloseClick);
        document.removeEventListener('keydown', this._onKeyDown);
      }
    }
  );
}
